module.exports = __webpack_public_path__ + "static/media/mail-icon.f5ee6498.svg";